
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/overview",
      function () {
        return require("private-next-pages/overview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/overview"])
      });
    }
  